
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 89.63 89.63"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M58.85 41.85h4v31.71H27.31V41.85h26.21M53.52 41.85l3.86-6.38A10 10 0 0054 21.8l-.39-.23A10 10 0 0040 24.92l-4.81 7.93-3.9-2.36 4.8-7.93A14.53 14.53 0 0156 17.68l.38.23a14.52 14.52 0 014.89 19.92l-2.44 4"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M45.28 50.37a12.38 12.38 0 01-5.63 1.91 13.42 13.42 0 005.63 13.23 13.4 13.4 0 005.63-13.23 12.38 12.38 0 01-5.63-1.91z"}})])
          )
        }
      }
    